export default "__VITE_ASSET__9e139ad7__"